import { z } from 'zod';
import { IsoTimeSchema, RevisionSchema, StableIdSchema, patchSchema } from './design-log.js';
export const BranchSchema = z.looseObject({
    id: StableIdSchema,
    gameId: StableIdSchema,
    name: z.string().min(1),
    gitRef: z.string().min(1),
    forkPoint: z
        .looseObject({
        parentBranchId: StableIdSchema,
        parentRev: RevisionSchema,
        gitSha: z
            .string()
            .regex(/^[0-9a-f]{40}$/)
            .nullable(),
    })
        .nullable(),
    headRev: RevisionSchema,
    latestBuildId: StableIdSchema.nullable(),
    status: z.enum(['active', 'archived', 'merged']),
    createdBy: StableIdSchema,
    createdAt: IsoTimeSchema,
});
export const FieldChangeSchema = z.looseObject({
    path: z.string(),
    before: z.unknown(),
    after: z.unknown(),
    txId: StableIdSchema,
});
export const SideDeltaSchema = z.record(z.string(), z.union([FieldChangeSchema, z.literal('deleted')]));
const conflictSideSchema = z.union([FieldChangeSchema, z.literal('deleted'), z.literal('removed_by_build')]);
const resolutionSchema = z.union([z.enum(['ours', 'theirs', 'both']), z.looseObject({ value: z.unknown() })]);
export const MergeConflictSchema = z.looseObject({
    id: StableIdSchema,
    path: z.string(),
    entityId: StableIdSchema.optional(),
    controlId: z.string().optional(),
    kind: z.enum(['both_changed', 'delete_vs_edit', 'control_removed']),
    ours: conflictSideSchema,
    theirs: conflictSideSchema,
    resolution: resolutionSchema.optional(),
});
export const MergePlanSchema = z.looseObject({
    id: StableIdSchema,
    gameId: StableIdSchema,
    sourceBranchId: StableIdSchema,
    targetBranchId: StableIdSchema,
    baseRev: RevisionSchema,
    auto: z.array(patchSchema),
    conflicts: z.array(MergeConflictSchema),
    code: z.union([z.enum(['clean', 'fast_forward']), z.looseObject({ conflictJobId: StableIdSchema })]),
    previewBuildId: StableIdSchema.optional(),
    status: z.enum(['planned', 'resolving', 'previewing', 'landed', 'abandoned']),
});
/**
 * Voice merge tools map directly to the merge routes:
 * - list_conflicts(planId) reads GET .../merges/:planId
 * - resolve_conflict(planId, conflictId, resolution) posts to .../conflicts/:conflictId
 * - resolve_all(planId, 'ours' | 'theirs') posts to .../resolve-all
 */
export const BranchesFamilySchema = z.looseObject({
    branch: BranchSchema,
    fieldChange: FieldChangeSchema,
    sideDelta: SideDeltaSchema,
    mergeConflict: MergeConflictSchema,
    mergePlan: MergePlanSchema,
});
export const branchesSchemas = {
    'branches.v1': BranchesFamilySchema,
};
//# sourceMappingURL=branches.js.map